import $ from 'jquery';
import JQueryView, { on } from '../../../common/views/jqueryView';

export default class InvestorContactView extends JQueryView {
  constructor() {
    super('.investor_contact');
  }

  @on({ event: 'click', selector: '#scroll-button' })
  onClickScrollButton(e: JQuery.ClickEvent) {
    e.preventDefault();
    const offset = $('#lp-form').offset()?.top;

    if (offset !== undefined) {
      $('html, body').animate({ scrollTop: offset }, 600);
    }
  }
}
